import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { PopupModal } from '@/components/common/Modal'
import DatePicker from '@/components/common/DatePicker/DatePicker.vue'
import * as dateutil from '@/util/date-helper'
@Component({
    components: {
        PopupModal,
        DatePicker
    }
})
export default class RecurringEndDateModal extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Boolean, default: false }) show!: boolean
    @Prop({ type: Object }) value!: calendar.CalendarItem;

    localRecurrence: calendar.CalendarItemRecurrence = {
        startDate: dateutil.uGetDateFormat('yyyy-MM-dd', new Date()),
        endDate: dateutil.uGetDateFormat('yyyy-MM-dd', dateutil.uGetDate(90)),
        ui_useRecurringButton: true,
        ui_useDefaultDate: true,
        ui_useRecurringDisplay: false,
        ui_useRecurring: false,
        ui_recurringType: 1,
        monthValue: (new Date().getMonth() + 1),
        firstDayOfWeekValue: 1,
        daysOfTheWeekArray: [] as number[],
        dayOfMonth: 1,
        ui_endType: '1',
        interval: 1,
        numberOfOccurrences: 0
    } as calendar.CalendarItemRecurrence;

    check() {
        this.$emit('check', null, this.localRecurrence.ui_endType, this.localRecurrence.numberOfOccurrences)
    }

    setEndDate(date: string) {
        this.$emit('check', date, '3', 0)
    }
}
